import { CalendarEventListDTO } from './calendar-event-list.dto';

export class OwnerCalendarEventsDTO {

    id: string;

    firstName?: string;

    lastName?: string;

    name?: string;

    events: Array<CalendarEventListDTO>;

}
